// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"28":"94c9626f321176b373c6","38":"f5dd81bcbeef333940ff","899":"f5dd81bcbeef333940ff"}[chunkId] + ".css";
};